import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateFileObject } from '@/courses/interfaces/params-create-file-object.interface';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import EdCreateSubdeckObject from '../ed-create-subdeck-object/ed-create-subdeck-object.vue';
import EdCreateOtherFilesObject from '../ed-create-other-files-object/ed-create-other-files-object.vue';

@Component({
  components: {
    EdCreateSubdeckObject 
  }
})
export default class EdCourseCreateSubDeckObject extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: IParamsCourseObject;      //Typescript upgrade
  declare readonly params: IParamsCourseObject;
  
  public loaded: boolean = false;
  public fileComponent: any = null;

  get courseId() {
    return this.params.courseId;
  }

  get classId() {
    return this.params.classId;
  }

  get parentId() {
    return this.params.parentId;
  }

  get section() {
    return this.params.section;
  }

  onClose() {
    this.$EdModal.closeModal();
  }

  created() {    
  }
}